import { useEffect, useState } from 'react';
import { useLocation, useNavigate, useSearchParams } from 'react-router-dom';
import { clsx } from 'clsx';
import { useAppSelector } from 'src/store';
import { useMenuItems } from 'src/components/PageContentWrapper/MenuBarItems';
import { useGetUsersMeQuery } from 'src/services/usersService';
import { ROUTE_PATHS } from 'src/utils/route-paths';
import { API_VERSION } from 'src/constants/api-routes';
import { getApiVersion } from 'src/utils/apiVersion';

export const MenuBarComponent = () => {
  const [activeIndex, setActiveIndex] = useState(0);
  const location = useLocation();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  const isProjectLocation = location.pathname.includes('projects');
  const isAccountLocation = location.pathname.includes('account');
  const isAnalyticsLocation = location.pathname.includes('analytics');
  const isSubscriptionLocation = location.pathname.includes('subscription');
  const isIntegrationsLocation = location.pathname.includes('integrations');
  const isConversationLocation = location.pathname.includes('conversations');
  const isAiKnowledgeBaseLocation = location.pathname.includes(ROUTE_PATHS.AI_KNOWLEDGE_BASE);
  const isHomeLocation = location.pathname.includes(ROUTE_PATHS.HOME);
  const isPlaygroundLocation = location.pathname.includes('playground');
  const isControlDeskLocation = location.pathname.includes('control-desk');
  const isConfigurationLocation = location.pathname.includes('configuration');
  const { projectType } = useAppSelector((s) => s.projectsSlices);
  const type = projectType || searchParams.get('type');
  const { data: userInfo } = useGetUsersMeQuery();
  const role = userInfo?.role;
  const version = getApiVersion();
  const isV2 = version === API_VERSION.V2;

  useEffect(() => {
    if (isProjectLocation || isControlDeskLocation) {
      setActiveIndex(0);
    }
    if (isAnalyticsLocation) {
      setActiveIndex(1);
    }
    if (isIntegrationsLocation) {
      setActiveIndex(3);
    }
    if (isConversationLocation) {
      setActiveIndex(4);
    }
    if (isPlaygroundLocation) {
      setActiveIndex(5);
    }
    if (isConfigurationLocation) {
      setActiveIndex(6);
    }
  }, []);

  const menuBarItems = useMenuItems(type);

  const barHandleClick = (href: string) => {
    navigate(`${href}${location.search}`);
  };

  const isProject = isProjectLocation ?? isAnalyticsLocation;
  return (
    <div
      className={clsx('absolute flex gap-10 -top-[36px] z-10 overflow-auto w-[calc(100%-195px)]')}
    >
      {isProject ? (
        menuBarItems
          .filter((item) => item.visibleFor?.includes(type))
          .filter((item) => item.roles.includes(role))
          .map((item) => {
            if (isV2 && item.title === 'Analytics') {
              return null;
            }

            return (
              <button
                type="button"
                onClick={() => barHandleClick(item.href)}
                key={item.id}
                className={clsx(
                  'flex pb-[14px] border-ebony cursor-pointer transition',
                  activeIndex === item.id
                    ? 'border-b-2 pointer-events-none'
                    : 'opacity-50 hover:opacity-100',
                  item.disabled && 'opacity-50 pointer-events-none',
                )}
              >
                <p className="font-bold text-ebony text-sm text-nowrap">{item.title}</p>
              </button>
            );
          })
      ) : (
        <div
          className={clsx(
            isHomeLocation && 'border-transparent',
            'flex pb-3.5 border-b-2 border-ebony cursor-pointer',
          )}
        >
          <p className="font-bold text-sm text-nowrap text-ebony">
            {(isAccountLocation && 'Account') ||
              (isSubscriptionLocation && 'Subscription') ||
              (isAiKnowledgeBaseLocation && 'AI Knowledge Bases') ||
              (isHomeLocation && 'Welcome to CoSupport AI Hub!')}
          </p>
        </div>
      )}
    </div>
  );
};
